"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MAPBOX_TOKEN: "pk.eyJ1IjoiaGFja29yZWdvbiIsImEiOiJjamk0MGZhc2cwNDl4M3FsdHAwaG54a3BnIn0.Fq1KA0IUwpeKQlFIoaEn_Q",
  CIVIC_LIGHT: "mapbox://styles/hackoregon/cjiazbo185eib2srytwzleplg",
  CIVIC_PENCIL: "mapbox://styles/hackoregon/ck0blt1d63wrm1cqhcnccrf9s",
  CIVIC_DARK: "mapbox://styles/mapbox/dark-v9",
  SANDBOX_DARK: "mapbox://styles/hackoregon/cjyluzgci27k41crxywr2gqnr",
  DISASTER_GAME: "mapbox://styles/hackoregon/cjzki4sok5wgd1cmxadz9xdxi"
};
exports["default"] = _default;